import { fetchTokenAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const hyperproof = defineConnector({
  identifier: "hyperproof",
  name: "Hyperproof",
  tagLine: "Compliance operations",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://[^/]*\\.hyperproof\\.app/.*",
  auth: (app) =>
    fetchTokenAuth({
      request: {
        url: "https://accounts.hyperproof.io/oauth/token",
        jsonBody: {
          grant_type: "client_credentials",
          client_id: app.secret.clientId,
          client_secret: app.secret.clientSecret,
          audience: "https://api.hyperproof.io",
        },
      },
      extract: { from: "jsonPath", paths: ["access_token"] },
      apply: { kind: "header", scheme: "Bearer" },
    }),
  steps: [
    {
      title: "Create API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "In Hyperproof, navigate to **Settings → API** and create a new API client. Copy the client ID and client secret.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "secrets", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "secrets", field: "clientSecret" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://accounts.hyperproof.app/oauth/token",
  },
});
